import { useState } from 'react';

import { selectUserHasStartedToFillForm } from '@/domain/external/external.selectors';
import { useAppSelector } from '@/ui/hook/store';

export type Step = 'start' | 'form' | 'done';

const INITIAL_STEP: Step = 'start';

export function useExternalSteps() {
  const [step, setStep] = useState<Step>(INITIAL_STEP);

  const userHasStartedToFill = useAppSelector(selectUserHasStartedToFillForm);

  if (step === 'start' && userHasStartedToFill) {
    setStep('form');
  }

  return { step, setStep };
}
